module.exports = __webpack_public_path__ + "img/altitude-resort-8.024d83dd.jpg";